<mat-card style="margin-top: 30px">
  <mat-card-header>
    <h2 mat-card-title><mat-icon>list_alt</mat-icon>Migrations</h2>
    @if (!isAutoLoadChecked) {
      <!-- <div class="filter-migrations">
        <mat-form-field appearance="outline" class="migrations-search-field">
          <input
            matInput
            [(ngModel)]="migrationsSearchText"
            (ngModelChange)="onMigrationsSearchChanged($event)"
            placeholder="Search migrations"
          />
          @if (migrationsSearchText) {
            <button
              mat-icon-button
              matSuffix
              aria-label="Clear search"
              (click)="clearMigrationsSearch()"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </div> -->
    }
    <div class="toogle-container">
      <mat-slide-toggle
        [(ngModel)]="isAutoLoadChecked"
        (ngModelChange)="onAutoLoadToggled($event)"
        class="toogle-auto-load"
      >
        Auto-load
      </mat-slide-toggle>
      <button
        mat-mini-fab
        (click)="executeMigrations(null)"
        color="primary"
        class="refresh-fab"
        aria-label="Refresh migration list"
      >
        <mat-icon>cached</mat-icon>
      </button>
      <button
        mat-raised-button
        (click)="exportToExcel()"
        [disabled]="migrations.length === 0 || exporting"
        class="export-btn"
      >
        <mat-spinner
          diameter="20"
          [style.display]="exporting ? 'inline-block' : 'none'"
        ></mat-spinner>
        <mat-icon [style.display]="exporting ? 'none' : 'inline-block'"
          >download</mat-icon
        >
        <span [style.display]="exporting ? 'none' : 'inline'">Export</span>
      </button>
    </div>
  </mat-card-header>
  <mat-card-content>
    <div class="table-container">
      <app-table-grid
        [data]="migrations"
        [displayedColumns]="displayedColumns"
        [headers]="columnHeaders"
        [customStyleColumns]="{
          status: 'statusCss',
          post_process_status: 'postProcessStatusCss'
        }"
        [columnsLink]="['id']"
        [isLoading]="loading"
        [usingAutoLoad]="isAutoLoadChecked"
        [skeletonRowsCount]="paginatorFilter.pageSize"
        [enableSorting]="true"
        [serverSideSorting]="true"
        [columnSortTypes]="columnSortTypes"
        [defaultSortColumn]="currentSortColumn"
        [defaultSortDirection]="currentSortDirection"
        (cellClicked)="onCellClicked($event)"
        (sortChanged)="onSortChanged($event)"
      ></app-table-grid>
    </div>
    @if (!loading && migrations.length > 0) {
      <mat-paginator
        showFirstLastButtons="true"
        [length]="paginatorFilter.count"
        [pageIndex]="paginatorFilter.currentPage"
        [pageSize]="paginatorFilter.pageSize"
        [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="paginateMigrations($event)"
        class="mat-elevation-z8"
      >
      </mat-paginator>
    }

    @if (!loading && migrations.length === 0) {
      @if (!isFirstLoad) {
        <div class="no-migrations">
          <mat-icon class="no-data-icon">info_outline</mat-icon>
          <p>No records match your filters.</p>
        </div>
      }
    }
  </mat-card-content>
  <mat-card-footer>
    *enabling auto-load will update the migrations in a real time manner
  </mat-card-footer>
</mat-card>

<mat-accordion style="margin-top: 30px; display: block">
  <mat-expansion-panel
    (opened)="onDeletedPanelOpened()"
    [expanded]="deletedExpanded"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon style="margin-right: 8px">delete_outline</mat-icon>
        Deleted Migrations
        @if (deletedMigrations.length > 0) {
          <span class="deleted-count-badge">{{
            deletedMigrations.length
          }}</span>
        }
      </mat-panel-title>
      <mat-panel-description> View deleted migrations </mat-panel-description>
    </mat-expansion-panel-header>

    @if (deletedLoading) {
      <div style="display: flex; justify-content: center; padding: 20px">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }

    @if (!deletedLoading && deletedMigrations.length > 0) {
      <app-table-grid
        [data]="deletedMigrationsPaginated"
        [displayedColumns]="deletedMigrationsColumns"
        [headers]="deletedMigrationsHeaders"
        [customStyle]="
          'font-family: monospace;font-size: 12px;max-width: 600px;'
        "
        [customStyleColumn]="'status'"
        [customStylepProp]="'statusCss'"
        [isLoading]="deletedLoading"
        [skeletonRowsCount]="deletedPaginatorFilter.pageSize"
      ></app-table-grid>
      <mat-paginator
        showFirstLastButtons="true"
        [length]="deletedPaginatorFilter.count"
        [pageIndex]="deletedPaginatorFilter.currentPage"
        [pageSize]="deletedPaginatorFilter.pageSize"
        [pageSizeOptions]="[5, 10, 25]"
        (page)="paginateDeletedMigrations($event)"
        class="mat-elevation-z8"
      >
      </mat-paginator>
    }

    @if (!deletedLoading && deletedMigrations.length === 0) {
      <div class="no-migrations">There are no deleted migrations.</div>
    }
  </mat-expansion-panel>
</mat-accordion>
